// TournamentBoardDisplay.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './Board.css';
import { useGame } from './context/GameContext';
import { useSound } from './sfx/SoundProvider';
import tournamentSocket from './tournamentSocket';

const TournamentBoardDisplay = ({
  tournamentBoard,
  tournamentBoardState,
  countdownMessage,
  tournamentPlayer1Name,
  tournamentPlayer2Name,
  tournamentOpponentName,
  handleTournamentFirstMove,
  tournamentFirstRolls,
  tournamentPlayer1Roll,
  tournamentPlayer2Roll,
  tournamentCountdown,
  tournamentHandleReadyClick,
  tournamentSchetchik,
  tournamentFirstRollComplete,
  tournamentShowReadyButton,
  tournamentHasRolledDice,
  tournamentCurrentTurn,
  handleTournamentRollDiceClick,
  tournamentShowUndoButton,
  tournamentHandleUndoMove,
  tournamentNumberMove,
  tournamentConfirmMove,
  tournamentWhiteOffBoard,
  tournamentSetWhiteOffBoard,
  tournamentBlackOffBoard,
  tournamentSetBlackOffBoard,
  tournamentOnPointClick,
  handleTournamentDragOver, // (оставляем для совместимости, но ниже используем tournamentHandleDragOver)
  tournamentHandleDragStart,
  handleTournamentDrop,     // (оставляем для совместимости, но ниже используем tournamentHandleDrop)
  tournamentOnCheckerClick,
  tournamentHandleDrop,
  tournamentHandleDragOver,
  tournamentHandleFirstRollClick,
  firstMoveComplete,
  player1Time,
  player2Time,
  tournamentTimeoutMsg,
  modalMessage,
  showModal,
  tournamentShowSurrenderButton,
  tournamentHandleSurrender,
  player1Avatar,
  player2Avatar,
  player1ShortRating,
  player2ShortRating,
  tournamentStageLabel,
  tournamentPrize,
  autoRoll,
  autoConfirm,
  onToggleAutoRoll,
  onToggleAutoConfirm,

  // остальные пропсы
}) => {
  const { t: translate } = useTranslation();

  /* ====== контекст игры ====== */
  const {
    tournamentCapturedCheckers,
    tournamentRolledDice,
    tournamentReadyStatus,
    tournamentRollEnabled,
    setTournamentRollEnabled,
    tournamentGame,
    setTournamentFirstRollComplete,
    tournamentIsFirstMoveDone,
    tournamentFlagFirst,
    setTournamentFlagFirst,
    setTournamentRolledDice,
    setTournamentBoardState,
    tournamentPlayerColor,
    setTournamentPlayerColor,
    tournamentOpponentColor,
    setTournamentOpponentColor,
   
  } = useGame();

  /* ====== SFX ====== */
  const { play } = useSound();
  const playSfx = (name) => {
    try {
      const p = play?.(name);
      if (p && typeof p.then === 'function') p.catch(() => {});
    } catch (_) {}
  };

  // обёртки с SFX
  const onPointClickSfx = (pt, label) => {
    playSfx('click');
    tournamentOnPointClick?.(pt, label);
  };
  const onDragStartSfx = (e, from, idx, fromBar = false) => {
    playSfx('click');
    tournamentHandleDragStart?.(e, from, idx, fromBar);
  };
  const onDropSfx = (e, to) => {
    playSfx('drop');
    (tournamentHandleDrop || handleTournamentDrop)?.(e, to);
  };
  const onUndoSfx = () => {
    playSfx('cancel');
    tournamentHandleUndoMove?.();
  };
  const onConfirmSfx = () => {
    playSfx('ok');
    tournamentConfirmMove?.();
  };
  // const onRollSfx = () => {
  //   playSfx('dice');
  //   handleTournamentRollDiceClick?.();
  // };
    const onRollSfx = () => {
    // ЗВУК БОЛЬШЕ НЕ ИГРАЕМ ЗДЕСЬ
    // Звук будет запускаться при фактическом появлении кубиков
    handleTournamentRollDiceClick?.();
  };

  const onSurrenderSfx = () => {
    playSfx('pass');
    tournamentHandleSurrender?.();
  };







  // ⬇️ ДОБАВЬ: локальный статус сети/сокета
const [net, setNet] = useState({
  online: tournamentSocket.connected,
  trying: !tournamentSocket.connected,
  attempt: 0,
  reason: null,
});

const hasConnectedOnceRef = useRef(false);

// ⬇️ ДОБАВЬ: подписки на события сокета + реакция на online/offline браузера
// useEffect(() => {
//   const onConnect = () =>
//     setNet({ online: true, trying: false, attempt: 0, reason: null });

//   const onDisconnect = (reason) => {
//     setNet((s) => ({ ...s, online: false, trying: true, reason: reason || 'disconnect' }));
//     // Если сервер сам разорвал соединение — инициируем переподключение
//     if (reason === 'io server disconnect') {
//       setTimeout(() => tournamentSocket.connect(), 500);
//     }
//   };

//   const onConnectError = (err) =>
//     setNet((s) => ({ ...s, online: false, trying: true, reason: err?.message || 'connect_error' }));

//   // Попытки реконнекта (через менеджер)
//   const onAttempt = (n) =>
//     setNet((s) => ({ ...s, trying: true, attempt: n || s.attempt + 1 }));

//   const onReconnected = () =>
//     setNet({ online: true, trying: false, attempt: 0, reason: null });

//   // Подписки
//   tournamentSocket.on('connect', onConnect);
//   tournamentSocket.on('disconnect', onDisconnect);
//   tournamentSocket.on('connect_error', onConnectError);

//   // события менеджера (кол-во попыток и пр.)
//   tournamentSocket.io?.on?.('reconnect_attempt', onAttempt);
//   tournamentSocket.io?.on?.('reconnect', onReconnected);
//   tournamentSocket.io?.on?.('reconnect_error', onConnectError);
//   tournamentSocket.io?.on?.('reconnect_failed', () =>
//     setNet((s) => ({ ...s, trying: false, reason: 'reconnect_failed' }))
//   );

//   // online/offline браузера — подсказываем пользователю и пробуем коннект
//   const goOffline = () =>
//     setNet((s) => ({ ...s, online: false, trying: true, reason: 'offline' }));
//   const goOnline = () => {
//     setNet((s) => ({ ...s, trying: true }));
//     tournamentSocket.connect();
//   };
//   window.addEventListener('offline', goOffline);
//   window.addEventListener('online', goOnline);

//   return () => {
//     tournamentSocket.off('connect', onConnect);
//     tournamentSocket.off('disconnect', onDisconnect);
//     tournamentSocket.off('connect_error', onConnectError);
//     tournamentSocket.io?.off?.('reconnect_attempt', onAttempt);
//     tournamentSocket.io?.off?.('reconnect', onReconnected);
//     tournamentSocket.io?.off?.('reconnect_error', onConnectError);
//     tournamentSocket.io?.off?.('reconnect_failed');
//     window.removeEventListener('offline', goOffline);
//     window.removeEventListener('online', goOnline);
//   };
// }, []);


  // «goodluck» один раз после определения, кто ходит первым (с мобильным фолбэком)
  const goodluckPlayedRef     = useRef(false);
  const gestureHandlerRef     = useRef(null);
  const suppressClickUntilRef = useRef(0);


    const hadDiceRef = useRef(false);
  // Предыдущее состояние первых бросков (кто ходит первым)
  const prevFirstRollsRef = useRef({
    player1Roll: null,
    player2Roll: null,
  });

  /* ====== отладочные логи (как у тебя) ====== */
  useEffect(() => {
    console.log('56756567575675', tournamentRolledDice, tournamentFirstRolls);
  }, [tournamentRolledDice, tournamentFirstRolls]);

  useEffect(() => {
    console.log('[TournamentBoardDisplay] Полученное состояние доски:', tournamentBoardState, tournamentBoard);
  }, [tournamentBoard, tournamentBoardState]);

  useEffect(() => {
    console.log('[tournamentNumberMove] Получено состояние:', tournamentHasRolledDice, tournamentCurrentTurn, tournamentPlayerColor);
  }, [tournamentHasRolledDice, tournamentCurrentTurn, tournamentPlayerColor]);



    // 🔊 Звук кубиков при обычных бросках (ручных и авто, своих и чужих)
  useEffect(() => {
    const hasDice =
      Array.isArray(tournamentRolledDice) && tournamentRolledDice.length > 0;

    // Переход "не было кубиков" -> "появились кубики"
    if (hasDice && !hadDiceRef.current) {
      hadDiceRef.current = true;
      playSfx('dice'); // этот звук услышат оба игрока
    }
    // Переход "кубики были" -> "кубиков нет" (конец хода)
    else if (!hasDice && hadDiceRef.current) {
      hadDiceRef.current = false;
    }
  }, [tournamentRolledDice, play]);

  // 🔊 Звук кубиков при первых бросках (определение, кто ходит первым)
  useEffect(() => {
    if (!tournamentFirstRolls) return;

    const prev = prevFirstRollsRef.current || {};
    const curr = tournamentFirstRolls;

    const p1Changed =
      Number.isInteger(curr.player1Roll) &&
      curr.player1Roll !== prev.player1Roll;

    const p2Changed =
      Number.isInteger(curr.player2Roll) &&
      curr.player2Roll !== prev.player2Roll;

    // Если у кого-то из игроков появился новый первый бросок — играем звук
    if (p1Changed || p2Changed) {
      playSfx('dice');
    }

    prevFirstRollsRef.current = {
      player1Roll: curr.player1Roll,
      player2Roll: curr.player2Roll,
    };
  }, [tournamentFirstRolls, play]);

  /* ====== мой/оппонент цвет ====== */
  const myTournamentColor =
    tournamentPlayerColor === 'white' || tournamentPlayerColor === 'black'
      ? tournamentPlayerColor
      : 'white';
  const opponentTournamentColor = myTournamentColor === 'white' ? 'black' : 'white';

  useEffect(() => {
    if (tournamentPlayerColor) {
      const opponentColor = tournamentPlayerColor === 'white' ? 'black' : 'white';
      setTournamentOpponentColor?.(opponentColor);
      console.log('[Tournament] Opponent Color:', opponentColor);
    }
  }, [tournamentPlayerColor, setTournamentOpponentColor]);

  useEffect(() => {
    console.log('Render Roll Dice Button Condition:', tournamentHasRolledDice, tournamentCurrentTurn, tournamentNumberMove, tournamentRolledDice);
  }, [tournamentHasRolledDice, tournamentCurrentTurn, tournamentNumberMove, tournamentRolledDice]);

  const playerReady =
    myTournamentColor === 'white'
      ? (tournamentReadyStatus?.player1 || false)
      : (tournamentReadyStatus?.player2 || false);

  useEffect(() => {
    console.log('[TournamentBoardDisplay] Смотрим на первые броски:', tournamentFirstRolls);
    console.log('Player1Roll:', tournamentPlayer1Roll, 'Player2Roll:', tournamentPlayer2Roll);
  }, [tournamentFirstRolls, tournamentPlayer1Roll, tournamentPlayer2Roll]);

  useEffect(() => {
    console.log('TournamentBoardDisplay props:', {
      tournamentBoard,
      tournamentOpponentName,
      tournamentPlayerColor,
      tournamentOpponentColor,
    });
  }, [tournamentBoard, tournamentOpponentName, tournamentPlayerColor, tournamentOpponentColor]);




useEffect(() => {
 const joinAndFetch = () => {
  const username       = localStorage.getItem('username') || '';
  const gameType       = localStorage.getItem('gameType');
  const rawTournamentId = localStorage.getItem('tournamentTableId');
  const rawTableId      = localStorage.getItem('tableId');

  let tableId = 0;
  if (rawTableId) {
    tableId = Number(rawTableId) || 0;
  } else if (rawTournamentId) {
    tableId = Number(rawTournamentId) || 0;
  }

  // 1) если вообще нет username — дальше смысла нет
  if (!username) {
    console.warn('[tbd] joinAndFetch: нет username, выходим', {
      username,
      gameType,
      rawTournamentId,
      rawTableId,
    });
    return;
  }

  // 2) если нет tableId — спрашиваем сервер, где активный матч
  if (!tableId) {
    console.warn('[tbd] joinAndFetch: нет tableId — пробуем спросить сервер', {
      username,
      gameType,
      rawTournamentId,
      rawTableId,
    });

    tournamentSocket.emit('tournament_checkActiveMatch', { userName: username }, (res) => {
      if (res?.tableId) {
        localStorage.setItem('tableId', String(res.tableId));
        localStorage.setItem('gameType', 'short');

        console.log('[tbd] восстановили матч через checkActiveMatch', res);

        tournamentSocket.emit('tournamentMatch_joinTable', {
          tableId: res.tableId,
          username,
        });
        tournamentSocket.emit('fetchTournamentData', res.tableId);
      } else {
        console.warn('[tbd] checkActiveMatch: активного матча нет', res);
      }
    });
    return;
  }

  // 3) обычный путь — уже знаем tableId
  console.log('[tbd] join+fetch after connect', { tableId, username, gameType });
  tournamentSocket.emit('tournamentMatch_joinTable', { tableId, username });
  tournamentSocket.emit('fetchTournamentData', tableId);
};


const onConnect = () => {
  console.log('[tbd] socket CONNECTED');

  // Если мы уже когда-то подключались раньше — это реконнект → просто перезагружаем вкладку
  if (hasConnectedOnceRef.current) {
    console.log('[tbd] RECONNECT detected → FORCE RELOAD');
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
    return;
  }

  // Первый коннект
  hasConnectedOnceRef.current = true;
  setNet({ online: true, trying: false, attempt: 0, reason: null });
  joinAndFetch();
};


  const onDisconnect = (reason) => {
    console.log('[tbd] socket DISCONNECT:', reason);
    setNet((s) => ({
      ...s,
      online: false,
      trying: true,
      reason: reason || 'disconnect',
    }));

    // ❗ тут БОЛЬШЕ НИЧЕГО не делаем, socket.io сам начнёт reconnection
    // если очень хочешь, можно оставить пинок только для io server disconnect:
    // if (reason === 'io server disconnect') {
    //   try { tournamentSocket.connect(); } catch (e) { ... }
    // }
  };

  const onConnectError = (err) => {
    console.log('[tbd] connect_error:', err?.message || err);
    setNet((s) => ({
      ...s,
      online: false,
      trying: true,
      reason: err?.message || 'connect_error',
    }));
  };

  const onAttempt = (n) => {
    console.log('[tbd] reconnect_attempt', n);
    setNet((s) => ({ ...s, trying: true, attempt: n || s.attempt + 1 }));
  };

//  const onReconnected = () => {
//   console.log('[tbd] RECONNECTED');
//   const token = localStorage.getItem('token') || '';
//   const username = localStorage.getItem('username') || '';
//   tournamentSocket.auth = token ? { token, username } : { username }; // 👈 добавь это
//   setNet({ online: true, trying: false, attempt: 0, reason: null });
//   joinAndFetch();
// };
  // const onReconnected = () => {
  //   console.log('[tbd] RECONNECTED');
  //   const token = localStorage.getItem('token') || '';
  //   const username = localStorage.getItem('username') || '';
  //   tournamentSocket.auth = token ? { token, username } : { username }; // 👈 добавь это
  //   setNet({ online: true, trying: false, attempt: 0, reason: null });
  //   joinAndFetch();
  // };


  tournamentSocket.on('connect', onConnect);
  tournamentSocket.on('disconnect', onDisconnect);
  tournamentSocket.on('connect_error', onConnectError);

  tournamentSocket.io?.on?.('reconnect_attempt', onAttempt);
  // tournamentSocket.io?.on?.('reconnect', onReconnected);
  tournamentSocket.io?.on?.('reconnect_error', onConnectError);
  tournamentSocket.io?.on?.('reconnect_failed', () => {
    console.log('[tbd] reconnect_failed');
    setNet((s) => ({ ...s, trying: false, reason: 'reconnect_failed' }));
  });

  const goOffline = () => {
    console.log('[tbd] window OFFLINE');
    setNet((s) => ({ ...s, online: false, trying: true, reason: 'offline' }));
  };

  const goOnline = () => {
    console.log('[tbd] window ONLINE');
    setNet((s) => ({ ...s, trying: true }));
    // здесь можно НЕ вызывать connect(), сокет сам будет пытаться
    // если очень хочешь — можно мягко пинать:
    // if (!tournamentSocket.connected) {
    //   try { tournamentSocket.connect(); } catch (e) { ... }
    // }
  };

  window.addEventListener('offline', goOffline);
  window.addEventListener('online', goOnline);

  if (tournamentSocket.connected) {
    joinAndFetch();
  }

  return () => {
    tournamentSocket.off('connect', onConnect);
    tournamentSocket.off('disconnect', onDisconnect);
    tournamentSocket.off('connect_error', onConnectError);

    tournamentSocket.io?.off?.('reconnect_attempt', onAttempt);
    // tournamentSocket.io?.off?.('reconnect', onReconnected);
    tournamentSocket.io?.off?.('reconnect_error', onConnectError);
    tournamentSocket.io?.off?.('reconnect_failed');

    window.removeEventListener('offline', goOffline);
    window.removeEventListener('online', goOnline);
  };
}, []);






// рядом с остальными SFX-обёртками
const onDragOverSfx = (e) => {
  // ВАЖНО: всегда разрешаем drop
  if (e && typeof e.preventDefault === 'function') e.preventDefault();
  (tournamentHandleDragOver || handleTournamentDragOver)?.(e);
};






  /* ====== картинки кубиков ====== */
  const diceImages = {
    white: {
      1: '/img/k1-white-1.png',
      2: '/img/k1-white-2.png',
      3: '/img/k1-white-3.png',
      4: '/img/k1-white-4.png',
      5: '/img/k1-white-5.png',
      6: '/img/k1-white-6.png',
    },
    black: {
      1: '/img/k1-black-1.png',
      2: '/img/k1-black-2.png',
      3: '/img/k1-black-3.png',
      4: '/img/k1-black-4.png',
      5: '/img/k1-black-5.png',
      6: '/img/k1-black-6.png',
    },
  };

  console.log('myTournamentColor=', myTournamentColor);
  console.log('tournamentCapturedCheckers=', tournamentCapturedCheckers);

  /* ====== валидность доски (без раннего return) ====== */
  const boardReady = Array.isArray(tournamentBoard) && tournamentBoard.length === 24;
  if (!boardReady && process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn('[TournamentBoardDisplay] board ещё не готов:', tournamentBoard);
  }

  /* ====== AVATAR URL RESOLVER ====== */
  const RAW_API =
    (typeof import.meta !== 'undefined' && (import.meta.env?.VITE_API_ORIGIN || import.meta.env?.VITE_API_URL)) ||
    process.env.REACT_APP_API_ORIGIN ||
    process.env.REACT_APP_API_URL ||
    '';

  const PAGE_PROTOCOL = (typeof window !== 'undefined' && window.location?.protocol) || 'http:';
  const PAGE_HOST     = (typeof window !== 'undefined' && window.location?.hostname) || 'localhost';
  const ENV_PORT =
    (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_PORT) ||
    process.env.REACT_APP_PORT ||
    (typeof window !== 'undefined' && window.location?.port === '3001' ? '5000' : '');

  let API_ORIGIN = '';
  if (/^https?:\/\//i.test(RAW_API)) {
    API_ORIGIN = RAW_API.replace(/\/+$/, '');
  } else if (RAW_API) {
    const hasPort = /:\d+$/.test(RAW_API);
    API_ORIGIN = `${PAGE_PROTOCOL}//${RAW_API}${hasPort ? '' : (ENV_PORT ? `:${ENV_PORT}` : '')}`.replace(/\/+$/, '');
  } else {
    API_ORIGIN = `${PAGE_PROTOCOL}//${PAGE_HOST}${ENV_PORT ? `:${ENV_PORT}` : ''}`.replace(/\/+$/, '');
  }

  const DEFAULT_AVATAR =
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96">
         <circle cx="48" cy="48" r="46" fill="#2b2b2b" stroke="#999" stroke-width="2"/>
       </svg>`
    );

  function resolveAvatarSrc(raw) {
    const s = String(raw || '').replace(/\\/g, '/').trim();
    if (!s) return DEFAULT_AVATAR;
    if (/^https?:\/\//i.test(s)) return s;
    if (/^\/?uploads\//i.test(s) || /^\/?api\/uploads\//i.test(s)) {
      return `${API_ORIGIN}/${s.replace(/^\/+/, '')}`;
    }
    return s.startsWith('/') ? s : `/${s}`;
  }

  const p1Src = resolveAvatarSrc(player1Avatar);
  const p2Src = resolveAvatarSrc(player2Avatar);

  // Пробуем прелоадить аватарки (хук всегда вызывается)
  useEffect(() => {
    const test = (label, url) => {
      if (!url || url === DEFAULT_AVATAR) return;
      const img = new Image();
      img.onload = () => console.log(`[AVATAR][probe] ${label}: OK →`, url);
      img.onerror = (e) => console.warn(`[AVATAR][probe] ${label}: ERROR →`, url, e);
      img.src = url;
    };
    test('P1', p1Src);
    test('P2', p2Src);
  }, [p1Src, p2Src]);

  // Мини-аватар с фолбэком на инициал, если src пустой/сломался
  const TbdAvatar = ({ src, name }) => {
    const [ok, setOk] = useState(Boolean(src));
    const initial = (name || '').trim().charAt(0).toUpperCase() || '•';

    if (!ok) {
      return <div className="tbd-avatar tbd-avatar-fallback">{initial}</div>;
    }
    return (
      <img
        className="tbd-avatar"
        src={src}
        alt={name || 'player'}
        onError={() => setOk(false)}
      />
    );
  };

  /* ====== формат времени ====== */
  function formatTime(seconds) {
    const min = Math.floor(seconds / 60).toString().padStart(1, '0');
    const sec = (seconds % 60).toString().padStart(2, '0');
    return `${min}:${sec}`;
  }

  /* ====== разбиение доски ====== */
  const firstBlack = Array.isArray(tournamentBoard) && tournamentBoard.length >= 24
    ? tournamentBoard.slice(0, 12)
    : [];
  const secondBlack = Array.isArray(tournamentBoard) && tournamentBoard.length >= 24
    ? tournamentBoard.slice(12).reverse()
    : [];
  const firstWhite = Array.isArray(tournamentBoard) && tournamentBoard.length >= 24
    ? tournamentBoard.slice(12).reverse()
    : [];
  const secondWhite = Array.isArray(tournamentBoard) && tournamentBoard.length >= 24
    ? tournamentBoard.slice(0, 12)
    : [];

  /* ====== goodluck SFX после первых бросков ====== */
  useEffect(() => {
    const ready =
      Number.isInteger(tournamentFirstRolls?.player1Roll) &&
      Number.isInteger(tournamentFirstRolls?.player2Roll);

    if (!ready) return;
    if (goodluckPlayedRef.current) return;

    if (gestureHandlerRef.current) {
      window.removeEventListener('pointerdown', gestureHandlerRef.current);
      gestureHandlerRef.current = null;
    }

    const onFirstGesture = async () => {
      if (goodluckPlayedRef.current) return;
      try {
        const r = play?.('goodluck');
        if (r && typeof r.then === 'function') await r;
      } catch (_) {
        // ignore
      } finally {
        goodluckPlayedRef.current = true;
        suppressClickUntilRef.current = Date.now() + 250;
        window.removeEventListener('pointerdown', onFirstGesture);
        gestureHandlerRef.current = null;
      }
    };

    try {
      const maybe = play?.('goodluck');
      if (maybe && typeof maybe.then === 'function') {
        maybe.then(() => {
          goodluckPlayedRef.current = true;
          suppressClickUntilRef.current = Date.now() + 250;
        }).catch(() => {
          if (!goodluckPlayedRef.current) {
            gestureHandlerRef.current = onFirstGesture;
            window.addEventListener('pointerdown', onFirstGesture, { once: true, passive: true });
          }
        });
      } else {
        gestureHandlerRef.current = onFirstGesture;
        window.addEventListener('pointerdown', onFirstGesture, { once: true, passive: true });
      }
    } catch (_) {
      gestureHandlerRef.current = onFirstGesture;
      window.addEventListener('pointerdown', onFirstGesture, { once: true, passive: true });
    }

    return () => {
      if (gestureHandlerRef.current) {
        window.removeEventListener('pointerdown', gestureHandlerRef.current);
        gestureHandlerRef.current = null;
      }
    };
  }, [tournamentFirstRolls, play]);

  /* ====== компактная отрисовка стека шашек (макс 5 + число) ====== */
  function renderStackedCheckers(point, { isTopRow, realIndex }) {
    const checkers = Array.isArray(point) ? point : [];
    const visible  = checkers.slice(0, 5);
    const total    = checkers.length;

    return visible.map((checker, i) => {
      if (!checker || !checker.color) return null;
      const color = String(checker.color).toLowerCase();
      const showCount = total > 5 ? (isTopRow ? i === visible.length - 1 : i === 0) : false;

      return (
        <div
          key={i}
          className={`checker ${color}`}
          draggable="true"
          onDragStart={(e) => onDragStartSfx(e, realIndex, i)}
          style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          {showCount && <span className="stack-count">{total}</span>}
        </div>
      );
    });
  }

  /* ====== точки (для белого/чёрного) ====== */
  const renderTournamentPoints = () => {
    if (myTournamentColor === 'white') {
      // == Для белого ==
      return (
        <>
          {/* Верхний ряд (white) */}
          <div className="top-row">
            {(firstWhite || []).map((point, index) => (
              <div
                key={index}
                className={`point-container p${index}`}
                onClick={() => onPointClickSfx(24 - index - 1, 24 - index)}
                onDragOver={onDragOverSfx}
                onDrop={(e) => onDropSfx(e, 24 - index - 1)}
              >
                <span>{24 - index}</span>
                {renderStackedCheckers(point, { isTopRow: true, realIndex: 24 - index - 1 })}
              </div>
            ))}
          </div>

          {/* Нижний ряд (white) */}
          <div className="bottom-row">
            {(secondWhite || []).map((point, index) => (
              <div
                key={index}
                className={`point-containerd r${index}`}
                onClick={() => onPointClickSfx(index, index + 1)}
                onDragOver={onDragOverSfx}

                onDrop={(e) => onDropSfx(e, index)}
              >
                {renderStackedCheckers(point, { isTopRow: false, realIndex: index })}
                <span>{index + 1}</span>
              </div>
            ))}
          </div>
        </>
      );
    }

    // == Для чёрного ==
    return (
      <>
        {/* Верхний ряд (black) */}
        <div className="top-row">
          {(firstBlack || []).map((point, index) => (
            <div
              key={index}
              className={`point-container p${index}`}
              onClick={() => onPointClickSfx(index, index + 1)}
              onDragOver={onDragOverSfx}
              onDrop={(e) => onDropSfx(e, index)}
            >
              <span>{index + 1}</span>
              {renderStackedCheckers(point, { isTopRow: true, realIndex: index })}
            </div>
          ))}
        </div>

        {/* Нижний ряд (black) */}
        <div className="bottom-row">
          {(secondBlack || []).map((point, index) => (
            <div
              key={index}
              className={`point-containerd r${index}`}
              onClick={() => onPointClickSfx(24 - index - 1, 24 - index)}
              onDragOver={onDragOverSfx}
              onDrop={(e) => onDropSfx(e, 24 - index - 1)}
            >
              {renderStackedCheckers(point, { isTopRow: false, realIndex: 24 - index - 1 })}
              <span style={{ color: 'white' }}>{24 - index}</span>
            </div>
          ))}
        </div>
      </>
    );
  };

  const displayStageLabel = (() => {
    const raw = String(tournamentStageLabel || '').trim();
    const value = raw.toLowerCase();

    if (!raw) return '';
    if (value.includes('полу') || value.includes('semi')) {
      return translate('jackpotBoard.stage.semifinal');
    }
    if (value.includes('финал') || value.includes('final')) {
      return translate('jackpotBoard.stage.final');
    }
    if (value.includes('квалиф') || value.includes('qualif')) {
      return translate('jackpotBoard.stage.qualification');
    }
    if (value.includes('rebuy')) {
      return translate('jackpotBoard.stage.rebuy');
    }

    return raw;
  })();

  /* ====== JSX ====== */
  return (
    // <div className={`board tbd-pos ${myTournamentColor === 'black' ? 'flipped' : ''}`}>
<div
  className={`board tbd-pos theme-neo ${/финал/i.test(tournamentStageLabel || '') ? 'is-final' : 'is-semi'} ${myTournamentColor === 'black' ? 'flipped' : ''}`}
>
  {/* ⬇️ ДОБАВЬ: лёгкая шторка во время реконнекта/обрыва */}
{(!net.online || net.trying) && <div className="tbd-netshade" />}

      {/* Баннер по таймауту */}
      {tournamentTimeoutMsg && (
        <div className={'timeout-banner ' + (tournamentTimeoutMsg.victory ? 'victory' : 'defeat')}>
          {tournamentTimeoutMsg.victory
            ? translate('jackpotBoard.opponentTimeout')
            : translate('jackpotBoard.ownTimeout')}
        </div>
      )}

      {/* Если доска ещё не готова — мягкий лоадер, БЕЗ раннего return */}
      {!boardReady && <div className="loading">{translate('jackpotBoard.loading')}</div>}

      <img src="/img/Board33.png" alt="Board" />

      {/* Аватарки и рейтинг по краям доски */}
      <div className="tbd-players-overlay">
        {/* Заголовок над доской */}
         <div className="tbd-stagebar">
    {tournamentStageLabel ? <div className="tbd-stage">{displayStageLabel}</div> : null}
    {tournamentPrize ? <div className="tbd-prize">{translate('jackpotBoard.prize')}: {tournamentPrize}</div> : null}
    </div>





{/* ⬇️ ДОБАВЬ: чип статуса сети */}
{(net.trying || !net.online) && (
  <div
    className={`tbd-conn-chip ${!net.online ? 'is-down' : 'is-trying'}`}
    role="status"
    aria-live="polite"
  >
    {navigator.onLine === false
      ? translate('jackpotBoard.noInternet')
      : !net.online
      ? translate('jackpotBoard.connectionLost')
      : translate('jackpotBoard.reconnecting', { attempt: net.attempt || 1 })}
    {net.reason && <span className="tbd-conn-reason"> ({net.reason})</span>}
  </div>
)}



        {/* Кнопка «Сдаться» как оверлей */}
        {tournamentShowSurrenderButton && (
          <button className="tbd-surrender" onClick={onSurrenderSfx} type="button">
            {translate('jackpotBoard.resign')}
          </button>
        )}

     <div className="tbd-side tbd-left tbd-card">
  <TbdAvatar src={p1Src} name={tournamentPlayer1Name} />
  <div className="tbd-meta">
    <div className="tbd-name">{tournamentPlayer1Name || ''}</div>
    {player1ShortRating && <div className="tbd-rating">{player1ShortRating}</div>}
    <div className="tbd-time">{formatTime(player1Time)}</div>
  </div>
</div>



   <div className="tbd-side tbd-right tbd-card">
  <TbdAvatar src={p2Src} name={tournamentPlayer2Name} />
  <div className="tbd-meta">
    <div className="tbd-name">{tournamentPlayer2Name || ''}</div>
    {player2ShortRating && <div className="tbd-rating">{player2ShortRating}</div>}
    <div className="tbd-time">{formatTime(player2Time)}</div>
  </div>
</div>


      </div>

      {/* Первый бросок (до первого хода) */}
      {!firstMoveComplete && tournamentFirstRolls && (
        <div className="first-rolls-display">
          {Number.isInteger(tournamentFirstRolls?.player1Roll) && (
            <img
              src={diceImages.white[tournamentFirstRolls.player1Roll]}
              alt={translate('jackpotBoard.firstRollP1', { value: tournamentFirstRolls.player1Roll })}
              className="dice-image first-roll-player1"
            />
          )}
          {Number.isInteger(tournamentFirstRolls?.player2Roll) && (
            <img
              src={diceImages.black[tournamentFirstRolls.player2Roll]}
              alt={translate('jackpotBoard.firstRollP2', { value: tournamentFirstRolls.player2Roll })}
              className="dice-image first-roll-player2"
            />
          )}
        </div>
      )}

      {/* Кнопка "Бросить кубики" после первого броска (если мой ход) */}
      {/* {!tournamentHasRolledDice &&
        tournamentFirstRollComplete &&
        tournamentCurrentTurn === (tournamentPlayerColor === 'white' ? 'player1' : 'player2') && (
          <button className="roll-dice-button" onClick={onRollSfx}>
            {translate('jackpotBoard.rollDice')}
          </button>
        )} */}
{!tournamentHasRolledDice &&
  tournamentFirstRollComplete &&
  tournamentCurrentTurn === (tournamentPlayerColor === 'white' ? 'player1' : 'player2') &&
  net.online && !net.trying && (
    <button className="roll-dice-button" onClick={onRollSfx} disabled={!net.online || net.trying}>
      {translate('jackpotBoard.rollDice')}
    </button>
)}

      {/* Отрисовка выпавших кубиков во время обычного хода */}
      {/* {tournamentRolledDice && tournamentRolledDice.length > 0 && firstMoveComplete && ( */}
      {Array.isArray(tournamentRolledDice) &&
  tournamentRolledDice.length > 0 &&
  firstMoveComplete && (
        <div className="dice-display">
          {tournamentRolledDice.map((val, idx) => {
            const isCurrentPlayer =
              tournamentCurrentTurn === (tournamentPlayerColor === 'white' ? 'player1' : 'player2');
            const diceSrc = isCurrentPlayer
              ? diceImages[tournamentPlayerColor]?.[val]
              : diceImages[opponentTournamentColor]?.[val];
            return <img key={idx} src={diceSrc} alt={`Dice ${val}`} />;
          })}
        </div>
      )}

      {/* Кнопка "Отмена" хода */}
      {/* {tournamentShowUndoButton && (
        <button className="undo-button" onClick={onUndoSfx}>
          {translate('jackpotBoard.undo')}
        </button>
      )} */}
{tournamentShowUndoButton && net.online && !net.trying && (
  <button className="undo-button" onClick={onUndoSfx} disabled={!net.online || net.trying}>
    {translate('jackpotBoard.undo')}
  </button>
)}

      {/* Кнопка "Завершить ход" */}
    {/* {tournamentHasRolledDice && */}
  {/* {tournamentCurrentTurn === (tournamentPlayerColor === 'white' ? 'player1' : 'player2') &&
  tournamentNumberMove === 0 && ( */}
  
 {/* {tournamentCurrentTurn === (tournamentPlayerColor === 'white' ? 'player1' : 'player2') &&
 tournamentNumberMove === 0 && (

    <button className="ok-button" onClick={onConfirmSfx}>
      <img src="/img/Ok.png" alt={translate('jackpotBoard.finishMove')} />
    </button>
)} */}
{tournamentHasRolledDice &&
  tournamentCurrentTurn ===
    (tournamentPlayerColor === 'white'
      ? 'player1'
      : 'player2') &&
  tournamentNumberMove === 0 &&
  net.online &&
  !net.trying && (
    <button
      type="button"
      className="ok-button tbd-ok-button"
      onClick={onConfirmSfx}
      disabled={!net.online || net.trying}
    >
      <img
        src="/img/Ok.png"
        alt={translate('jackpotBoard.finishMove')}
      />
    </button>
)}


      {/* Рисуем ячейки (top/bottom) */}
      {renderTournamentPoints()}

      {/* BAR: убитые шашки */}
      <div className="bar">
        {/* Шашки оппонента (верх бара) */}
        <div className="bar-opponentColor">
          {tournamentCapturedCheckers?.[opponentTournamentColor] > 0 && (
            <div
              className={`checker ${opponentTournamentColor} ${
                opponentTournamentColor === 'black' ? 'checkerBar' : 'checkerWhite'
              }`}
              draggable="true"
              onDragStart={(e) => onDragStartSfx(e, 25, 0, true)}
            >
              {tournamentCapturedCheckers[opponentTournamentColor] > 1
                ? tournamentCapturedCheckers[opponentTournamentColor]
                : opponentTournamentColor}
            </div>
          )}
        </div>

        {/* Ваши шашки (низ бара) */}
        <div className="bar-myColor">
          {tournamentCapturedCheckers?.[myTournamentColor] > 0 && (
            <div
              className={`checker ${myTournamentColor} ${
                myTournamentColor === 'black' ? 'checkerBar' : 'checkerWhite'
              }`}
              draggable="true"
              onDragStart={(e) => onDragStartSfx(e, 25, 0, true)}
              onClick={() => tournamentOnCheckerClick?.(25, myTournamentColor)}
            >
              {tournamentCapturedCheckers[myTournamentColor] > 1
                ? tournamentCapturedCheckers[myTournamentColor]
                : myTournamentColor}
            </div>
          )}
        </div>
      </div>

      {/* Off-board (выведенные шашки) */}
      <div className="off-board">
        {/* Оппонент (вверху) */}
        <div className="off-board-opponent">
          {(opponentTournamentColor === 'white'
            ? (tournamentWhiteOffBoard || [])
            : (tournamentBlackOffBoard || [])
          ).map((_, idx) => (
            <div
              key={idx}
              className={`checker ${opponentTournamentColor}`}
              style={{ top: `${idx * -10}px`, zIndex: idx }}
            />
          ))}
        </div>
        {/* Мои (внизу) */}
        <div className="off-board-my">
          {(myTournamentColor === 'white'
            ? (tournamentWhiteOffBoard || [])
            : (tournamentBlackOffBoard || [])
          ).map((_, idx) => (
            <div
              key={idx}
              className={`checker ${myTournamentColor}`}
              style={{ top: `${idx * -10}px`, zIndex: idx }}
            />
          ))}
        </div>
      </div>

      {/* Модалка */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <p>{modalMessage}</p>
          </div>
        </div>
      )}






       {/* Авто-действия (короткие): фикс снизу по центру */}
<div
  style={{
    position: 'fixed',
    bottom: -40,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1500,
    display: 'flex',
    gap: 12,
  }}
  role="group"
  aria-label={translate('jackpotBoard.autoSettingsShort')}
>
  {firstMoveComplete && firstMoveComplete &&
  <button
    type="button"
    onClick={onToggleAutoRoll}
    style={{
      padding: '8px 12px',
      borderRadius: 10,
      border: '1px solid #ccc',
      background: autoRoll ? '#e6ffed' : '#fff',
      cursor: 'pointer',
      fontWeight: 600
    }}
  >
    {translate('jackpotBoard.autoRoll')}: {autoRoll ? translate('jackpotBoard.on') : translate('jackpotBoard.off')}
  </button>
}

{firstMoveComplete && firstMoveComplete &&
  <button
    type="button"
    onClick={onToggleAutoConfirm}
    style={{
      padding: '8px 12px',
      borderRadius: 10,
      border: '1px solid #ccc',
      background: autoConfirm ? '#e6ffed' : '#fff',
      cursor: 'pointer',
      fontWeight: 600
    }}
  >
    {translate('jackpotBoard.autoConfirmShort')}: {autoConfirm ? translate('jackpotBoard.on') : translate('jackpotBoard.off')}
  </button>
}
</div>
    </div>
  );
};

export default TournamentBoardDisplay;


